module.exports = __webpack_public_path__ + "img/bkx.22f80e6.png";